import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { CruiseContentSections } from 'constants/cruise'

type CruiseContentSectionLabels = Record<Exclude<CruiseContentSections, CruiseContentSections.GALLERY>, string>

function useCruiseContentSectionLabels(): CruiseContentSectionLabels {
  const intl = useIntl()

  return useMemo(() => ({
    [CruiseContentSections.OVERVIEW]: intl.formatMessage({
      id: '_kmxGJ_zMZjIndd-l82h',
      defaultMessage: 'Overview',
      description: 'Cruise content section label for overview in the cruise section',
    }),
    [CruiseContentSections.ITINERARY]: intl.formatMessage({
      id: 'TUZMEjJooC-q3_0Y8r0U',
      defaultMessage: 'Itinerary',
      description: 'Cruise content section label for itinerary in the cruise section',
    }),
    [CruiseContentSections.ABOUT_THE_SHIP]: intl.formatMessage({
      id: 'GqKPbESrUN5hQTV21VpC',
      defaultMessage: 'About the Ship',
      description: 'Cruise content section label for ship information in the cruises section',
    }),
    [CruiseContentSections.DEPARTURES]: intl.formatMessage({
      id: 'BjG7f4YAotPV-vtevqcB',
      defaultMessage: 'Dates & Pricing',
      description: 'Cruise content section label for departure dates and pricing',
    }),
    [CruiseContentSections.DECKS_AND_CABINS]: intl.formatMessage({
      id: '-R5eF2XxdrSL2jcFZW-c',
      defaultMessage: 'Decks & Cabin types',
      description: 'Cruise content section label for decks and cabin types',
    }),
    [CruiseContentSections.FINE_PRINT]: intl.formatMessage({
      id: '2pDr9Jzf7m3IHD-K4VVF',
      defaultMessage: 'Things to know',
      description: 'Cruise content section label for fine print in the cruise section',
    }),
    [CruiseContentSections.FAQ]: intl.formatMessage({
      id: '_45yUUY5SIyzQhGWKixO',
      defaultMessage: 'Frequently Asked Questions',
      description: 'Cruise content section label for FAQ in the cruise offer or booking section',
    }),
  }), [intl])
}

export default useCruiseContentSectionLabels
